import { StyleSheet } from 'react-native';

/**
 * viewBox for the wave mask. Horizontal bleed (minX / width) so the arc’s endpoints sit
 * past the logical 0…400 span and map flush to the card edges after scale (no purple strips).
 */
export const MATCH_CARD_HERO_WAVE_VIEWBOX = {
  minX: -36,
  w: 472,
  h: 140,
} as const;

export const matchCardHeroShellLayoutStyles = StyleSheet.create({
  bgContainer: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 0,
  },
  gradientBand: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: '50%',
  },
  waveLayer: {
    position: 'absolute',
    left: 0,
    right: 0,
    /** Lower % = wave / arc sits higher (more purple above the curve) */
    top: '14%',
    zIndex: 1,
    overflow: 'visible',
  },
});
